var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"netvs-icon-wrapper",class:_vm.fade||_vm.beat_fade?'fade':''},[_c('svg',{staticClass:"netvs-icon",style:({width: _vm.px, height: _vm.px}),attrs:{"viewBox":"0 0 24 24","role":"img","aria-hidden":"true","focusable":"false"}},[_c('path',{attrs:{"d":_vm.resolve(_vm.icon),"fill":"currentColor"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }